import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";

import logoLight from "../../assets/images/logo-light.png";
import { getUserByToken, login } from "./request";
import { setAuthorization } from "../../helpers/api_helper";

const Login = (props: any) => {
  const history = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [Error, setError] = useState<any>("");

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      try {
        // Make the login request
        const auth = await login(values.email, values.password); // Assuming the token and other properties are in the data field

        if (auth?.token) {
          // Handle success
            const authentication: any = await getUserByToken(auth.token);
           console.log("Auth token:", auth.token);
          console.log("Authentication response:", authentication);
          // Check if auth object is valid
          if (authentication?.status === true) {
            // Store authUser in sessionStorage
            sessionStorage.setItem("authUser", JSON.stringify(authentication));
            localStorage.setItem(
              "authUser",
              JSON.stringify(authentication.user || authentication)
            );
            
            // Set the authorization header immediately
            setAuthorization(auth.token);
            
            console.log("Saved to localStorage:", localStorage.getItem("authUser"));
            // Optionally, store the token separately
            history("/dashboard");
            // Redirect or do any other necessary actions after successful login
          } else {
            // Handle invalid auth or authentication failure
            console.error("Invalid authentication data:", authentication);
            // Optionally, display an error message to the user
          }
        }
        else{
          console.error("dd:Login failed:", auth.message);
          setError("Authentication Failed!")
        }
      } catch (error) {
        console.error("Error occurred during login:", error);
        // Optionally, display an error message to the user
      }
    },
  });

  document.title = "Paal Dappa | Admin Panel";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-0 mb-0 text-white-50">
                  <div>
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="120" width="120" />
                  </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-3">
                  <CardBody className="p-3">
                    <div className="text-center mt-1">
                        <p className="text-muted fs-5">
                        Sign in to continue.
                        </p>
                    </div>
                    {Error ? (
                      <div className="d-flex justify-content-center">
                      <Alert color="danger" className="w-100 text-center">
                        {Error}
                      </Alert>
                      </div>
                    ) : null}
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        action="#"
                      >
                        <div className="mb-3">
                          <Label htmlFor="email" className="form-label">
                            Email
                          </Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter Email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <div className="float-end">
                            <Link to="/forgot-password" className="text-muted">
                              Forgot password?
                            </Link>
                          </div>
                          <Label
                            className="form-label"
                            htmlFor="password-input"
                          >
                            Password
                          </Label>
                          <div className="position-relative auth-pass-inputgroup mb-3">
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type={showPassword ? "text" : "password"}
                              className="form-control pe-5"
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                            <button
                              className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                              onClick={() => setShowPassword(!showPassword)}
                              type="button"
                              id="password-addon"
                            >
                                <i className="ri-eye-fill align-middle" style={{ marginRight: "20px" }}></i>
                            </button>
                          </div>
                        </div>

                        {/* <div className="form-check">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="auth-remember-check"
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="auth-remember-check"
                          >
                            Remember me
                          </Label>
                        </div> */}

                        <div className="mt-4">
                          <Button
                            color="success"
                            disabled={loader && true}
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            {loader && (
                              <Spinner size="sm" className="me-2">
                                {" "}
                                Loading...{" "}
                              </Spinner>
                            )}
                            Sign In
                          </Button>
                        </div>

                      
                      </Form>
                    </div>
                  </CardBody>
                </Card>

              
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
